import {
  MOCK_UNITED_STATES_EXPLORE_ITEMS,
  US_PROFILE_CATEGORY_PRIORITIES,
} from "./united-states";
import {
  ASIAN_PROFILE_CATEGORY_PRIORITIES,
  MOCK_ASIAN_EXPLORE_ITEMS,
} from "./asian";
import {
  CAUCASIAN_PROFILE_CATEGORY_PRIORITIES,
  MOCK_CAUCASIAN_EXPLORE_ITEMS,
} from "./caucasian";

import type { UserRecommendedItem } from "@/schemas/user/explore";
import type { Theme } from "@/screens/Authentication/Components/ProfileGrid/profileThemes";
import { MARKETING_THEME } from "@/utils/expo";

export type { ProfileCategoryPriority } from "./united-states";

export type RecommendationThemeConfig = {
  items: UserRecommendedItem[];
  categoryPriorities: {
    profileId: string;
    categories: { category: string; priority: number }[];
  }[];
};

export const recommendationThemeConfigs: Record<
  Theme,
  RecommendationThemeConfig
> = {
  "01-asian-theme": {
    items: MOCK_ASIAN_EXPLORE_ITEMS,
    categoryPriorities: ASIAN_PROFILE_CATEGORY_PRIORITIES,
  },
  "02-united-states-theme": {
    items: MOCK_UNITED_STATES_EXPLORE_ITEMS,
    categoryPriorities: US_PROFILE_CATEGORY_PRIORITIES,
  },
  "03-caucasian-theme": {
    items: MOCK_CAUCASIAN_EXPLORE_ITEMS,
    categoryPriorities: CAUCASIAN_PROFILE_CATEGORY_PRIORITIES,
  },
};

export function getActiveMarketingTheme(): RecommendationThemeConfig {
  return recommendationThemeConfigs[MARKETING_THEME];
}

// Named exports for each theme (for direct access)
export { MOCK_UNITED_STATES_EXPLORE_ITEMS, US_PROFILE_CATEGORY_PRIORITIES };
export { MOCK_ASIAN_EXPLORE_ITEMS, ASIAN_PROFILE_CATEGORY_PRIORITIES };
export { MOCK_CAUCASIAN_EXPLORE_ITEMS, CAUCASIAN_PROFILE_CATEGORY_PRIORITIES };
